import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-restaurantrightsidebar',
  templateUrl: './restaurantrightsidebar.component.html',
  styleUrls: ['./restaurantrightsidebar.component.css']
})
export class RestaurantrightsidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
